import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
  selector: 'app-quotation-footer',
  templateUrl: './quotation-footer.component.html',
  styleUrls: ['./quotation-footer.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.6s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('pulseAnimation', [
      state('pulse', style({ transform: 'scale(1.05)' })),
      transition('* => pulse', [
        animate('0.5s ease-in-out', style({ transform: 'scale(1.05)' })),
        animate('0.5s ease-in-out', style({ transform: 'scale(1)' }))
      ])
    ])
  ]
})
export class QuotationFooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  pulseState: string = '';

  constructor() { }

  ngOnInit(): void {
    // Add pulse animation every 10 seconds to draw attention to the back-to-top button
    setInterval(() => {
      this.pulseState = 'pulse';
      setTimeout(() => {
        this.pulseState = '';
      }, 1000);
    }, 10000);
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}